export const sanitizeLength = (length: Array<number | null>) => {
  if (!length) {
    return [];
  }

  const minLength = length[0] || 0;
  const maxLength = length[1] || 24;

  return [minLength, maxLength];
};
